export const fmt = (value) => Math.round(value).toLocaleString('sv-SE');
export const fmtMoney = (value) => (value ?? 0).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtCurrency = (value, currency) => `${fmtMoney(value)} ${(currency || 'SEK').trim().toUpperCase()}`;
export const fmtPercent = (value) => `${Math.round(value * 100)}%`;
export const fmtPercentPrecise = (value) => `${(value * 100).toLocaleString('sv-SE', { maximumFractionDigits: 1 })} %`;
export const fmtDate = (dateStr) => (dateStr ? dateStr.substring(0, 10) : '');

// Short axis label, e.g. 1,2 Mkr or 950 tkr
export const fmtCompact = (value) => (value >= 1000000
    ? `${(value / 1000000).toLocaleString('sv-SE', { maximumFractionDigits: 1 })} Mkr`
    : `${Math.round(value / 1000).toLocaleString('sv-SE')} tkr`);
